export const blockIconsMapsRateReview = (
	<span className='material-symbols-outlined'>rate_review</span>
);
